export const DOCS_BASE_PATH = "/docs";

export const DOCS_DEFAULT_ROUTE = "overview";

export const DOCS_DEFAULT_PATH = `${DOCS_BASE_PATH}/${DOCS_DEFAULT_ROUTE}`;

export const DOCS_DESKTOP_MIN_WIDTH = 1200;

export const DOCS_NAVBAR_HEIGHT = 72;

export const PLACEHOLDER_NOTE =
  "TODO(docs): Replace with approved BRD content.";

export const DOCS_MESSAGES = {
  noContentAvailable: "No content available.",
};


